import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { setData, setIsSaveDraft } from '../../../features/aiBotSlice';
import Button from '../../shared/Button';
import PageTitle from '../PageTitle';
import Model from './Model';
import Name from './Name';
import Platforms from './Platforms';

const useStyles = makeStyles(
  {
    root: {},
  },
  {
    name: 'BasicSettingContainer',
  },
);

const BasicSettingContainer = ({ pathKey }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { orgId, id } = useParams();
  const { data, isSaved } = useSelector(store => store.aiBot);
  const { integration } = useSelector(store => store.organization);

  const { name, model, platforms, provider } = data;

  const handleChange = value => {
    dispatch(setData(value));
    dispatch(setIsSaveDraft(true));
  };

  const handleNext = () => {
    history.push(`/${pathKey}/${orgId}/${id}/triggerSetting`);
  };

  return (
    <div className={classes.root}>
      <PageTitle title={t(`${pathKey}:basicSetting`)} />
      <Name
        onChange={v => handleChange({ name: v })}
        value={name}
        isSaved={isSaved}
      />
      <Model onChange={handleChange} model={model} provider={provider} />
      <Platforms
        onChange={handleChange}
        platforms={platforms}
        integration={integration || []}
      />
      <Button topic="primaryGreen" onClick={handleNext}>
        {t('next')}
      </Button>
    </div>
  );
};

export default BasicSettingContainer;
